import { render, staticRenderFns } from "./u-select-solo-tile.vue?vue&type=template&id=6f5839ae&scoped=true"
import script from "./u-select-solo-tile.vue?vue&type=script&lang=js"
export * from "./u-select-solo-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5839ae",
  null
  
)

export default component.exports